// Each title's public reader origin, from /api/me (Settings.public_base_url_for):
// www.* when the title is live, next.* on dev, preview.* before go-live.
//
// Never hardcode a reader host in the admin UI — that is how production's
// admin ended up linking every article to the dev site (2026-10-13).
// While /api/me is loading the map is empty, so links are omitted rather
// than pointed at a guessed host.

import { useQuery } from '@tanstack/react-query'
import { api, type MeResponse } from '../api/client'

export type PublicBaseUrls = Record<string, string>

export function usePublicBaseUrls(): PublicBaseUrls {
  const { data } = useQuery<MeResponse>({
    queryKey: ['me'], queryFn: () => api.get<MeResponse>('/api/me'), staleTime: 60_000, retry: false,
  })
  return data?.public_base_urls ?? {}
}

export function usePublicBaseUrl(publicationSlug: string): string | undefined {
  return usePublicBaseUrls()[publicationSlug]
}
